export default __webpack_public_path__ + "static/media/envelopeHero.6540b3cb.jpg";